var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSpringBoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 1.92a3.2 3.2 0 0 1 3.2 0l10.4 6a3.2 3.2 0 0 1 1.6 2.77v12.62a3.2 3.2 0 0 1-1.6 2.77l-10.4 6a3.2 3.2 0 0 1-3.2 0l-10.4-6a3.2 3.2 0 0 1-1.6-2.77V10.69a3.2 3.2 0 0 1 1.6-2.77z",
    fill: "#6DB33F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.2v6.6",
    stroke: "#fff",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 12.3a6.6 6.6 0 1 0 8.8 0",
    stroke: "#fff",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpringBoot);
export default __webpack_public_path__ + "static/media/logo-spring-boot.6366c2a4de259be555a63daa47bd6362.svg";
export { ForwardRef as ReactComponent };